/* eslint-disable no-extend-native */
import React, { useEffect, useState } from 'react'
import { Page, Text, View, Document, StyleSheet, ReactPDF, PDFViewer } from '@react-pdf/renderer';

const PdfViewer = (props) => {
    // week function
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    // stateful pdfs
    const [ pdfArray, setPdfArray ] = useState([])

    // content
    const [ content, setContent ] = useState(null)

    // map the props
    useEffect( () => {
        console.log(props)
        if (props.data.length > 0) {
            let localArray = []
            const styles = StyleSheet.create({
                page: {
                  flexDirection: 'column',
                  backgroundColor: '#E4E4E4',
                  fontSize: 12
                },
                topSection: {
                    flexDirection: 'row',
                },
                section: {
                  margin: 10,
                  padding: 10,
                  flexGrow: 1
                }, 
                secondSection: {
                    flexDirection: 'column',
                },
                bottomSection: {
                    display: 'flex',
                    flexDirection: 'row'
                },
                description: {
                    marginLeft: 10,
                    width: 180,
                    textAlign: 'left'
                },
                quantity: {
                    width: 70,
                    textAlign: 'right'
                },
                unitPrice: {
                    width: 100,
                    textAlign: 'right'
                },
                vat: {
                    width: 100,
                    textAlign: 'right'
                },
                amountGbp: {
                    width: 80,
                    marginRight: 10,
                    textAlign: 'right'
                },
                horizontalRule: {
                    borderBottomColor: 'black',
                    borderBottomWidth: 1,
                    width: '90%',
                    margin: 10
                },
                horizontalRuleHalf: {
                    borderBottomColor: 'black',
                    borderBottomWidth: 1,
                    width: '50%',
                    margin: 10,
                    marginLeft: 250
                },
                horizontalRuleGrey: {
                    borderBottomColor: 'grey',
                    borderBottomWidth: 1,
                    width: '90%',
                    margin: 10
                },
                horizontalRuleNone: {
                    borderBottomColor: '#E4E4E4',
                    borderBottomWidth: 1,
                    width: '90%',
                    margin: 10
                }
              });
            props.data.forEach( invoice => {
                let subtotal = invoice[11].grossIncome
                let supportArray = []
                let supportObj = {}
                invoice[5].support.forEach( support => {
                    supportObj[support.name] ? supportObj[support.name] += support.amount : supportObj[support.name] = support.amount;
                })
                let arrayOfkeys = Object.keys(supportObj)
                for (let item in supportObj) {
                    subtotal+=supportObj[item]
                    if (item !== arrayOfkeys[Object.keys(supportObj).length-1]) {
                        supportArray.push(
                            <>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}>{item}</Text>
                                    <Text style={styles.quantity}>1.00</Text>
                                    <Text style={styles.unitPrice}>{supportObj[item]}</Text>
                                    <Text style={styles.vat}>{invoice[10].vat ? '20%' : 'Zero Rated'}</Text>
                                    <Text style={styles.amountGbp}>{supportObj[item]}</Text>
                                </View>
                                <View style={styles.horizontalRuleGrey}/>
                            </>
                        )
                    } else if (arrayOfkeys[Object.keys(supportObj).length-1] === undefined) {
                        supportArray.push(
                            <>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}>{item}</Text>
                                    <Text style={styles.quantity}>1.00</Text>
                                    <Text style={styles.unitPrice}>{supportObj[item]}</Text>
                                    <Text style={styles.vat}>{invoice[10].vat ? '20%' : 'Zero Rated'}</Text>
                                    <Text style={styles.amountGbp}>{supportObj[item]}</Text>
                                </View>
                            </>
                        )
                    } else {
                        supportArray.push(
                            <>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}>{item}</Text>
                                    <Text style={styles.quantity}>1.00</Text>
                                    <Text style={styles.unitPrice}>{supportObj[item]}</Text>
                                    <Text style={styles.vat}>{invoice[10].vat ? '20%' : 'Zero Rated'}</Text>
                                    <Text style={styles.amountGbp}>{supportObj[item]}</Text>
                                </View>
                            </>
                        )
                    }
                }
                supportArray.push(
                    <>
                        <View style={styles.horizontalRule}/>
                        <View style={styles.bottomSection}>
                            <Text style={styles.description}> </Text>
                            <Text style={styles.quantity}> </Text>
                            <Text style={styles.unitPrice}> </Text>
                            <Text style={styles.vat}>Subtotal</Text>
                            <Text style={styles.amountGbp}>{subtotal}</Text>
                        </View>
                        <View style={styles.horizontalRuleNone}/>
                        <View style={styles.bottomSection}>
                            <Text style={styles.description}> </Text>
                            <Text style={styles.quantity}> </Text>
                            <Text style={styles.unitPrice}> </Text>
                            <Text style={styles.vat}>Total 20%</Text>
                            <Text style={styles.amountGbp}>{subtotal}</Text>
                        </View>
                    </>
                )
                localArray.push(
                    <Document>
                        <Page size="A4" style={styles.page}>
                            <View style={styles.topSection}>
                                <View style={styles.section}>
                                    <Text>To: H20 Logistics Limited</Text>
                                    <Text>Henleaze House</Text>
                                    <Text>13 Harbury Road</Text>
                                    <Text>Bristol</Text>
                                    <Text>BS9 4Pn</Text>
                                </View>
                                <View style={styles.section}>
                                    <Text>Invoice Date</Text>
                                    <Text>{new Date(invoice[6].date).toDateString('en-GB')}</Text>
                                    <Text>  </Text>
                                    <Text>Reference Number</Text>
                                    <Text>WEEK {new Date(invoice[6].date).getWeek()} INV {invoice[7].invoiceNumber} {invoice[8].station}</Text>
                                </View>
                                <View style={styles.section}>
                                    <Text>{invoice[0].name}</Text>
                                </View>
                            </View>
                            <View style={styles.secondSection}>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}>Description</Text>
                                    <Text style={styles.quantity}>Quantity</Text>
                                    <Text style={styles.unitPrice}>Unit Price</Text>
                                    <Text style={styles.vat}>Vat</Text>
                                    <Text style={styles.amountGbp}>Amount GBP</Text>
                                </View>
                                <View style={styles.horizontalRule}/>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}>Gross Income</Text>
                                    <Text style={styles.quantity}>1.00</Text>
                                    <Text style={styles.unitPrice}>{invoice[11].grossIncome}</Text>
                                    <Text style={styles.vat}>{invoice[10].vat ? '20%' : 'Zero Rated'}</Text>
                                    <Text style={styles.amountGbp}>{invoice[11].grossIncome}</Text>
                                </View>
                                <View style={styles.horizontalRuleGrey}/>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}>Miles</Text>
                                    <Text style={styles.quantity}>{invoice[2].miles}</Text>
                                    <Text style={styles.unitPrice}>0.165</Text>
                                    <Text style={styles.vat}>{invoice[10].vat ? '20%' : 'Zero Rated'}</Text>
                                    <Text style={styles.amountGbp}>{parseFloat(parseFloat(invoice[2].miles)*.165).toFixed(2)}</Text>
                                </View>
                                <View style={styles.horizontalRuleGrey}/>
                                {supportArray}
                                <View style={styles.horizontalRuleHalf}/>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}> </Text>
                                    <Text style={styles.quantity}> </Text>
                                    <Text style={styles.unitPrice}> </Text>
                                    <Text style={styles.vat}>TOTAL GBP</Text>
                                    <Text style={styles.amountGbp}>{invoice[1].total}</Text>
                                </View>
                                <View style={styles.horizontalRuleNone}/>
                                <View style={styles.bottomSection}>
                                    <Text style={styles.description}> </Text>
                                    <Text style={styles.quantity}> </Text>
                                    <Text style={styles.unitPrice}> </Text>
                                    <Text style={styles.vat}>DUE DATE</Text>
                                    <Text style={styles.amountGbp}>{new Date(invoice[6].date).addDays(6).toDateString('en-GB')}</Text>
                                </View>
                            </View>
                        </Page>
                    </Document>
                )
            })
            setPdfArray(localArray)
        }
    }, [props])
    
    // render the pdfs
    useEffect( () => {
        if (pdfArray.length > 0) {
            console.log(pdfArray)
            let localRenderArray = []
            pdfArray.forEach( (pdf, pdfId) => {
                localRenderArray.push(
                    <div className='singlePdfContainer'>
                        <PDFViewer>
                            {pdfArray[pdfId]}
                        </PDFViewer>
                    </div>
                )
            })
            setContent(
                <div className='pdfViewer'>
                    <div className='contentContainer'>
                        <h1>Pdfs</h1>
                        <div className='pdfContainer'>
                            {localRenderArray}
                        </div>
                    </div>
                </div>
            )
        }
    }, [pdfArray])

    return(
        <>
            {content}
            <button 
            className='returnButtonForPdfs'
            onClick={props.returnScreen}>Return</button>
        </>
    )
}

export default PdfViewer